export const MetaKeys = {
  editState: "editState",
  collapsed: "collapsed",
  completed: "completed"
};
